export default __webpack_public_path__ + "static/media/Payment.21ae8b74.webp";